<script lang="ts">
import {contractVariables} from "$lib/utils/templating/contractVariables.js";
import {Button, Fileupload, Modal, Search, Select, Spinner} from "flowbite-svelte";
import {onMount} from "svelte";
import {
    deleteDocumentTemplate,
    getDocumentTemplates,
    updateContractTemplate,
    uploadContractTemplate
} from "$lib/calls/settings";
import SortableTable from "$lib/components/SortableTable.svelte";
import {contractTypes} from "$lib/utils/templating/contractTypes";
import {contractTemplates} from "$lib/utils/tableHeaders/contractTemplates";
import ContractFields from "$lib/partials/settings/ContractFields.svelte";
import {CirclePlusSolid} from "flowbite-svelte-icons";

let showPlaceholder = false
let showContractModal = false
let templates:any[] = [];
let files:FileList = [];
let contractType:string;
let selectedContract:any;

let uploading = false;
let newVersionModal = false;
let uploadModal = false;

let search = '';

const upload = async () => {
    if(!files[0].name.endsWith('.docx')){
        alert('Nur MS Word Dateien erlaubt (.docx-Dateien)')
        return;
    }
    uploading = true;
    templates = [await uploadContractTemplate(files[0], contractType), ...templates];
    files = [];
    uploading = false;

}
const deleteTemplate = async (id:number) => {
    await deleteDocumentTemplate(templates.find(x => x.id === id));
    templates = [...templates.filter(x => x.id !== id)];
}

const editFields = async (id:number) => {
    selectedContract = templates.find(x => x.id === id);
    showContractModal = true;
}
const newVersionProcess = async (id:number) => {
    selectedContract = templates.find(x => x.id === id);
    newVersionModal = true
}
const update = async () => {
    if(!files[0].name.endsWith('.docx')){
        alert('Nur MS Word Dateien erlaubt (.docx-Dateien)')
        return;
    }
    uploading = true;
    const res = updateContractTemplate(files[0], selectedContract.contractType, selectedContract.id);
    templates = [...templates.filter(x => x.id !== selectedContract.id), res];
    files = [];
    uploading = false;
    newVersionModal = false;

}

onMount(async () => {
    templates = await getDocumentTemplates();

})
</script>
<div class="flex gap-3">
    <Search bind:value={search}/>
    <div>
        <Button  on:click={() => uploadModal = true}><CirclePlusSolid/></Button>
    </div>
</div>
<Modal size="xl" bind:open={uploadModal} title="Vorlage erstellen">
    <form class="flex gap-3 mt-3" on:submit|preventDefault={upload}>
        <div>
            <Button color="alternative" on:click={() => showPlaceholder =! showPlaceholder}>Show placeholder</Button>
        </div>
        <div class="flex-1">
            <Fileupload placeholder="Word Vorlage"  bind:files required />
        </div>
        <div>
            <Select placeholder="Vertragsart" items={contractTypes} bind:value={contractType} required />
        </div>
        <div>
            {#if uploading}
                <Spinner size={4} />
            {:else}
                <Button type="submit">upload</Button>
            {/if}
        </div>
    </form>
</Modal>

<SortableTable data={templates.filter(x => x.templateType === 'contract')} header={contractTemplates(deleteTemplate, editFields, newVersionProcess)}>

</SortableTable>
<Modal bind:open={newVersionModal} title="Neue Version">
    <p>Neue Version erstellen: {selectedContract.name} <span class="text-sm">({selectedContract.contractType})</span></p>
    <div class="flex gap-3">
        <Fileupload class="flex-1" placeholder="Word Vorlage"  bind:files required />
        <Button on:click={() => update()}>upload</Button>
    </div>

</Modal>
<Modal size="xl" bind:open={showContractModal} title="Vertragsvorlage">
    {#if showContractModal}
        <ContractFields bind:contract={selectedContract} />
    {/if}
</Modal>

<Modal bind:open={showPlaceholder} title="Placeholder">
    {#each Object.keys(contractVariables) as key}
        <p>{contractVariables[key]}</p>
    {/each}
</Modal>